import { Component, DoCheck } from '@angular/core';
import {NavigationStart, Router} from '@angular/router';

import { CustomerService } from './shared/services/customer.service';
import { DtmService } from './services/dtm.service';

@Component({
    selector: 'pme-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements DoCheck {
  constructor(
    private customerService: CustomerService,
    private router: Router,
    public dtmService: DtmService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.checkSelfAttendanceRouteWithoutClassification(event.url)) {
          const url = this.getCorrectSelfAttendanceUrl(event.url);
          this.router.navigateByUrl(url);
        }
      }
    });
  }

  ngDoCheck(): void {
    const dataLayer = sessionStorage.getItem('dataLayer');
    const customer = sessionStorage.getItem('customer');

    if (dataLayer !== null) {
      this.dtmService.getSessionDataLayer();
    }

    if (customer !== null) {
      this.customerService.getCustomerOnSessionStorage();
    }
  }

  getCorrectSelfAttendanceUrl(url: string): string {
    url = url.replace(/auto-atendimento\/alteracao-de-pagamento/, 'auto-atendimento/saude-do-seu-negocio/alteracao-de-pagamento');
    url = url.replace(/auto-atendimento\/cancelamento/, 'auto-atendimento/saude-do-seu-negocio/cancelamento');
    url = url.replace(/auto-atendimento\/upgrade/, 'auto-atendimento/saude-do-seu-negocio/upgrade');
    return url;
  }

  checkSelfAttendanceRouteWithoutClassification(url: string): boolean {
    return url.indexOf('auto-atendimento/alteracao-de-pagamento') > 0 ||
      url.indexOf('auto-atendimento/cancelamento') > 0 ||
      url.indexOf('auto-atendimento/upgrade') > 0;
  }

}
